import {AppType} from '@/classes/app/app-const';

export default class App {
  public static host: string;
  public static appType: AppType;
  public static request: any;
  public static url: string;
}
